// extracted by mini-css-extract-plugin
export default {"page":"rY-z","cartModal":"sY-z","checkout":"tY-z","placeholder":"uY-z","account":"vY-z"};